import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LivePresentationCard = ({ presentations }) => {
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  const isLive = (startTime, endTime) => {
    const now = new Date();
    const start = new Date(startTime);
    const end = new Date(endTime);
    return now >= start && now <= end;
  };

  const upcomingSessions = presentations?.filter(p => !isLive(p?.startTime, p?.endTime));
  const liveSessions = presentations?.filter(p => isLive(p?.startTime, p?.endTime));

  return (
    <div className="bg-card rounded-lg shadow-md p-4 md:p-5 lg:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-5 lg:mb-6">
        <Icon name="Video" size={20} color="var(--color-primary)" />
        <h3 className="text-base md:text-lg lg:text-xl font-heading font-semibold text-foreground">
          Live Presentations
        </h3>
        {liveSessions?.length > 0 && (
          <span className="ml-auto px-2 py-1 bg-error text-error-foreground text-xs font-semibold rounded-full animate-pulse">
            LIVE
          </span>
        )}
      </div>
      <div className="space-y-3 md:space-y-4">
        {liveSessions?.map((session) => (
          <div
            key={session?.id}
            className="p-4 md:p-5 bg-gradient-to-r from-error/10 to-error/5 border-2 border-error rounded-lg"
          >
            <div className="flex items-start justify-between gap-3 mb-3">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-1 bg-error text-error-foreground text-xs font-semibold rounded-full animate-pulse">
                    LIVE NOW
                  </span>
                  <span className="text-xs text-muted-foreground data-text">
                    {session?.attendees} watching
                  </span>
                </div>
                <h4 className="text-sm md:text-base font-semibold text-foreground mb-1 line-clamp-2">
                  {session?.title}
                </h4>
                <p className="text-xs text-muted-foreground">
                  {session?.presenter} • {formatTime(session?.startTime)} - {formatTime(session?.endTime)}
                </p>
              </div>
            </div>
            <Button
              variant="default"
              fullWidth
              iconName="Video"
              iconPosition="left"
            >
              Join Live Session
            </Button>
          </div>
        ))}

        {upcomingSessions?.map((session) => (
          <div
            key={session?.id}
            className="p-4 md:p-5 bg-muted rounded-lg hover:bg-muted/80 transition-smooth"
          >
            <div className="flex items-start justify-between gap-3 mb-3">
              <div className="flex-1 min-w-0">
                <h4 className="text-sm md:text-base font-semibold text-foreground mb-1 line-clamp-2">
                  {session?.title}
                </h4>
                <p className="text-xs text-muted-foreground mb-2">
                  {session?.presenter}
                </p>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Icon name="Clock" size={14} />
                  <span className="data-text">
                    {formatTime(session?.startTime)} - {formatTime(session?.endTime)}
                  </span>
                </div>
              </div>
            </div>
            <Button
              variant="outline"
              fullWidth
              size="sm"
              iconName="Bell"
              iconPosition="left"
            >
              Set Reminder
            </Button>
          </div>
        ))}

        {presentations?.length === 0 && (
          <div className="text-center py-8">
            <Icon name="Calendar" size={48} color="var(--color-muted-foreground)" />
            <p className="mt-3 text-sm text-muted-foreground">
              No presentations scheduled at this time
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LivePresentationCard;